// @ts-ignore
const images = require.context('../games/images', true, /\.(png|jpg|jpeg|gif|svg|mp4)$/);

// Helper to get asset URL
export const getImageUrl = (path: string): string => {
  try {
    // require.context keys are relative to the directory, e.g., "./welcome/bg.png"
    // If the input path is "welcome/bg.png", we need to prepend "./"
    const key = path.startsWith('./') ? path : `./${path}`;
    const module = images(key) as any;
    return (typeof module === 'string' ? module : module.default) as string;
  } catch (e) {
    console.error(`Image not found: ${path}`, e);
    return '';
  }
};

export const getAllImages = (): string[] => {
  return images.keys()
    .filter((key: string) => !key.endsWith('.mp4'))
    .map((key: string) => {
      const module = images(key) as any;
      return (typeof module === 'string' ? module : module.default) as string;
    });
};
